import type { Anexo } from '../store/types';

// No navegador, a foto é escolhida pelo seletor de arquivos (no celular, ele já oferece a câmera).
export function useCameraFoto() {
  return { abrir: async (_o?: { frente?: boolean; dica?: string }): Promise<Anexo | null> => null, tela: null, disponivel: false };
}

/** No navegador não há câmera própria (o seletor de arquivos do celular já oferece a câmera). */
export async function permitirCamera() { return false; }
export function CameraTela(_: { onFim: (a: Anexo | null) => void; frente?: boolean; dica?: string }) { return null; }
